export default {
  articleManagement: {
    taggingStatus: {
      filterLabel: 'Estado de etiquetado',
      filterPlaceholder: 'Seleccione estado de etiquetado',
      colTitle: 'Etiquetas / Etiquetado',
      editAction: 'Editar etiquetas',
      pending: 'Pendiente',
      tagged: 'Etiquetado',
      toBeTagged: 'Re-etiquetar',
    },
    tagEdit: {
      title: 'Editar etiquetas de artículo',
      placeholder: 'Seleccione 2-4 de las etiquetas habilitadas',
      countHint: 'Recomendado: {min}-{max} etiquetas ({count} seleccionadas)',
      saveOk: 'Etiquetas guardadas',
      loadTagsFail: 'Error al cargar diccionario de etiquetas',
      loadCurrentFail: 'Error al cargar etiquetas actuales, seleccione de nuevo',
    },
      aiReworkBtn: "Reescribir con IA",
      submitOnlyDraft: "Solo los artículos en borrador pueden ser enviados para revisión",
    title: 'Gestión de artículos',
    addNew: 'Nuevo artículo',
    createTitle: 'Nuevo artículo',
    editTitle: 'Editar artículo',
    batchDelete: 'Eliminar en lote',
    batchUpdateStatus: 'Actualizar estado en lote',
    batchAssignAuthor: 'Asignar autor en lote',
    confirmBatchDelete: '¿Está seguro de que desea eliminar los artículos seleccionados?',
    selectRows: 'Seleccione artículos primero',
    status: {
      draft: 'Borrador',
      pending: 'Pendiente de revisión',
      pendingReview: 'Pendiente de revisión',
      published: 'Publicado',
      rejected: 'Rechazado',
      offline: 'Desconectado',
    },
    source: {
      manual: 'Manual',
      ai: 'Generado por IA',
    },
    scoreLevel: {
      excellent: 'Excelente',
      good: 'Bueno',
      warning: 'Necesita mejoras',
      fail: 'Por debajo del estándar',
    },
    stats: {
      total: 'Total',
      draft: 'Borrador',
      pending: 'Pendiente',
      published: 'Publicado',
      rejected: 'Rechazado',
      offline: 'Desconectado',
    },
    actions: {
      viewLive: 'Ver en vivo',
      edit: 'Editar',
      aiRewrite: '🤖 Reescribir con IA',
      preview: 'Vista previa',
      score: 'Puntuación',
      reScore: 'Repuntuar',
      submitReview: 'Enviar para revisión',
      resubmit: 'Reenviare',
      review: 'Revisar',
      approve: 'Aprobar',
      reject: 'Rechazar',
      offline: 'Desconectar',
      delete: 'Eliminar',
      returnToDraft: 'Volver a borrador',
      confirmOffline: '¿Está seguro de que desea desconectar este artículo?',
      confirmDelete: '¿Está seguro de que desea eliminar este artículo?',
      scoreHint: 'La puntuación SEO/GEO debe ser ≥ 70 para enviar para revisión',
      submitReviewIllegal: 'El estado del artículo no permite envío — asegúrese de que esté en estado de borrador',
    },
    form: {
      keyword: 'Título del artículo',
      keywordPlaceholder: 'Buscar título',
      language: 'Idioma',
      languagePlaceholder: 'Seleccione idioma',
      category: 'Categoría',
      categoryPlaceholder: 'Seleccione categoría',
      status: 'Estado',
      statusPlaceholder: 'Seleccione estado',
      source: 'Fuente',
      sourcePlaceholder: 'Seleccione fuente',
      author: 'Autor',
      authorPlaceholder: 'Seleccione autor',
      authorFilter: 'Autor',
      authorFilterPlaceholder: 'Buscar nombre de autor',
      scoreMin: 'Puntuación mín.',
      scoreMax: 'Puntuación máx.',
      scoreRange: 'Rango de puntuación',
      dateRange: 'Fecha de actualización',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin',
      title: 'Título',
      titlePlaceholder: 'Ingrese título del artículo',
      titleRequired: 'Ingrese título del artículo',
      slug: 'URL',
      slugPlaceholder: 'Generada automáticamente, puede modificarla',
      tags: 'Etiquetas',
      tagsPlaceholder: 'Separadas por comas, ej.: casino,guía,2025',
      articleSource: 'Fuente del artículo',
      sourceManual: 'Escritura manual',
      sourceAI: 'Generar con IA →',
      sourceAIHint: 'Redirige al generador de contenido con IA. El contenido generado aparecerá en Gestión de artículos.',
      scheduledPublish: 'Programar publicación',
      scheduledTime: 'Hora de publicación',
      scheduledTimePlaceholder: 'Seleccione fecha y hora de publicación',
      summary: 'Resumen',
      summaryPlaceholder: 'Ingrese resumen del artículo',
      content: 'Contenido',
      coverImage: 'Imagen de portada',
      coverImageHint: 'La imagen de portada se usa como imagen OG por defecto',
      keywords: 'Palabras clave relacionadas',
      keywordsPlaceholder: 'Busque palabras clave en el centro de palabras clave',
      relatedKeywordsHint: 'La primera palabra clave es principal; las demás son secundarias',
      keywordFilter: 'Palabra clave objetivo',
      keywordFilterPlaceholder: 'Filtrar artículos por palabra clave',
      secondaryKeywords: 'Palabras clave secundarias',
      secondaryKeywordsPlaceholder: 'Seleccione palabras clave secundarias (múltiples)',
      rejectReason: 'Motivo del rechazo',
      rejectReasonPlaceholder: 'Ingrese motivo del rechazo',
      rejectReasonRequired: 'Ingrese motivo del rechazo',
      seoTitle: 'Título SEO',
      seoTitlePlaceholder: 'Recomendado 50-60 caracteres',
      seoTitleCount: '{count} caracteres',
      seoTitleWarn: 'Recomendado 50-60 caracteres para mejor SEO',
      seoDescription: 'Meta descripción',
      seoDescriptionPlaceholder: 'Recomendado 100-160 caracteres',
      seoDescCount: '{count} caracteres',
      seoDescWarn: 'Recomendado 100-160 caracteres para mejor SEO',
      canonical: 'URL canónica',
      canonicalPlaceholder: 'URL canónica',
      metaRobots: 'Meta Robots',
      ogImage: 'Imagen OG',
      assignAuthor: 'Asignar autor',
      assignAuthorPlaceholder: 'Seleccione autor',
      targetStatus: 'Estado objetivo',
      articleType: 'Tipo de artículo',
      articleTypeRequired: 'Seleccione tipo de artículo',
      articleTypePlaceholder: 'Seleccione tipo de artículo',
      languageRequired: 'Seleccione idioma',
      slugRequired: 'Ingrese URL',
      authorRequired: 'Seleccione autor',
      seoTitleRequired: 'Ingrese título SEO',
      seoDescRequired: 'Ingrese meta descripción',
      ogTitle: 'Título OG',
      ogTitlePlaceholder: 'Título OG',
      ogDescription: 'Descripción OG',
      ogDescriptionPlaceholder: 'Descripción OG',
    },
    serp: {
      title: 'Vista previa de Google SERP',
      urlExample: 'https://sitio.com/articulo',
    },
    review: {
      title: 'Revisión de artículo',
      info: 'Información del artículo',
      seoScore: 'Puntuación SEO/GEO',
      checkItems: 'Lista de verificación de revisión',
      submitInfo: 'Información de envío',
      submittedBy: 'Enviado por',
      submittedAt: 'Enviado en',
      seoInfo: 'Información SEO',
      keywords: 'Palabras clave objetivo',
      wordCount: 'Cantidad de palabras',
      chars: 'caracteres',
      comment: 'Comentario de revisión',
      commentPlaceholder: 'Ingrese comentarios de revisión (requerido al rechazar)',
      commentRequired: 'Ingrese comentario de revisión al rechazar',
      btnReturnToDraft: 'Volver a borrador',
      btnReject: 'Rechazar',
      btnApprove: 'Aprobar y publicar',
      approveSuccess: 'Artículo aprobado y publicado',
      rejectSuccess: 'Artículo rechazado',
      confirmText: '¿Está seguro de que desea aprobar y publicar este artículo?',
      returnSuccess: 'Vuelto a borrador',
      checkHasTitle: 'Tiene título',
      checkHasSlug: 'Tiene URL',
      checkHasSeoTitle: 'Tiene título SEO',
      checkHasSeoDesc: 'Tiene meta descripción',
      checkHasCover: 'Tiene imagen de portada',
      checkHasAuthor: 'Tiene autor asignado',
      checkScorePass: 'Puntuación SEO ≥ 80',
      pass: 'Aprobado',
      warn: 'Advertencia',
      fail: 'Fallido',
    },
    batchAuthor: {
      title: 'Asignar autor en lote',
      label: 'Autor',
      required: 'Seleccione un autor',
      success: 'Autor asignado exitosamente',
      apiFail: 'Error en API de asignación en lote. Contacte al backend para confirmar que el extremo está disponible.',
    },
    batchDeleteApiFail: 'Error en API de eliminación en lote. Contacte al backend para confirmar que el extremo está disponible.',
    batchUpdateStatusApiFail: 'Error en API de actualización de estado en lote. Contacte al backend para confirmar que el extremo está disponible.',
    loadDetailFailed: 'Error al cargar detalle del artículo. Cierre y reintente para evitar sobrescribir el contenido original.',
    table: {
      cover: 'Portada',
      title: 'Título',
      category: 'Categoría',
      keywords: 'Palabras clave objetivo',
      author: 'Autor',
      seoScore: 'SEO',
      geoScore: 'GEO',
      totalScore: 'Puntuación total',
      source: 'Fuente',
      status: 'Estado',
      updateTime: 'Actualizado en',
      action: 'Acciones',
    },
    tabs: {
      basic: 'Información básica',
      seo: 'Configuración SEO',
    },
    saveDraft: 'Guardar borrador',
    keywordRelSaveWarn: 'Artículo guardado, pero error al guardar relaciones de palabras clave — reintente en el editor',
    inlinkBtn: 'Enlaces internos',
    inlinkModalTitle: 'Sugerencias de enlaces internos',
    inlinkInjectBtn: 'Insertar enlaces ({n})',
    inlinkInjectOk: 'Se insertaron {n} enlace(s) interno(s) en el contenido. Haz clic en "Aceptar" para guardar el artículo.',
    inlinkEmpty: 'No se encontraron enlaces candidatos',
    inlinkHint: 'Los enlaces seleccionados se insertan en la primera aparición del texto ancla en el cuerpo (sin incluir títulos). Después haz clic en "Aceptar" para guardar el artículo; de lo contrario se perderán.',
    inlinkNoneInsertable: 'Nada que insertar: los candidatos ya están enlazados o el texto ancla no aparece en el contenido',
    inlinkStatusLinked: 'Ya enlazado',
    inlinkStatusMissing: 'Texto ancla no aparece en el contenido',
    inlinkStatusSelf: 'Apunta a este artículo',
    inlinkReasonLinked: 'El contenido ya enlaza a {url}; no es necesario insertarlo de nuevo',
    inlinkReasonMissing: 'El texto ancla "{anchor}" no aparece en el contenido, por lo que no hay dónde insertarlo. Añade la frase al contenido y vuelve a abrir las sugerencias, o añade el enlace manualmente en el editor',
    inlinkReasonNoTarget: 'Este candidato no tiene URL de destino y no se puede insertar',
    inlinkReasonSelf: 'El destino es este mismo artículo; no se insertan autoenlaces',
    inlinkUnsavedTip: 'Se insertaron enlaces internos pero aún no se han guardado. Haz clic en "Aceptar" para guardar el artículo; cerrar sin guardar los descartará.',
    inlinkUnsavedConfirmTitle: 'Enlaces internos sin guardar',
    inlinkUnsavedConfirmOk: 'Descartar y cerrar',
    inlinkUnsavedConfirmBack: 'Volver a guardar',
    viewJsonLdBtn: 'JSON-LD',
    jsonLdModalTitle: 'Vista previa de JSON-LD (solo lectura)',
    previewBtn: 'Vista previa',
    scoreBtn: 'Puntuación primero',
    submitReviewBtn: 'Enviar para revisión',
    scoreGateTooltip: 'La puntuación SEO debe ser ≥ 80 para enviar para revisión (actual: {score})',
    openLiveTitle: 'Abrir página H5 en vivo',
    openAuthorTitle: 'Abrir página del autor (H5)',
    kwFilterBanner: 'Filtrando por palabra clave relacionada: ',
    kwFilterClear: 'Limpiar filtro',
    liveBaseUrlMissing: 'URL base del sitio (h5BaseUrl) no configurada; página en vivo no disponible',
    liveUnavailable: 'No publicado — página en vivo no disponible',
    unsignedAuthor: 'Sin firmar',
  },

  articleTag: {
    addBtn: 'Añadir etiqueta',
    backfillBtn: 'Llenar',
    listTitle: 'Diccionario de etiquetas',
    frm: {
      tagName: 'Nombre de etiqueta',
      tagNamePlaceholder: 'Buscar nombre de etiqueta',
      status: 'Estado',
      statusAll: 'Todo',
    },
    status: {
      enabled: 'Habilitado',
      disabled: 'Deshabilitado',
    },
    col: {
      tagName: 'Nombre de etiqueta',
      status: 'Estado',
      usageCount: 'Artículos referenciados',
      createUser: 'Creado por',
      updateTime: 'Actualizado en',
      action: 'Acción',
    },
    deleteConfirmTitle: 'Eliminar etiqueta',
    deleteConfirmContent: '¿Eliminar etiqueta "{name}"?',
    deleteInUse: 'La etiqueta es referenciada por artículos y no puede ser eliminada',
    deleteDisabledTip: 'No se puede eliminar mientras artículos referenciados > 0',
    edit: {
      createTitle: 'Añadir etiqueta',
      editTitle: 'Editar etiqueta',
      tagName: 'Nombre de etiqueta',
      tagNamePlaceholder: 'Ingrese nombre de etiqueta',
      tagNameRequired: 'Nombre de etiqueta requerido',
      status: 'Estado',
      createOk: 'Etiqueta creada',
      saveOk: 'Etiqueta guardada',
      duplicate: 'Nombre de etiqueta ya existe',
    },
    config: {
      title: 'Configuración del modelo de etiquetado',
      model: 'Modelo de etiquetado',
      modelPlaceholder: 'Seleccione un modelo',
      modelRequired: 'Seleccione un modelo de etiquetado',
      modelLoadFail: 'Error al cargar lista de modelos; asegúrese de que el servicio del modelo de etiquetado esté implementado',
      autoTagging: 'Habilitar etiquetado automático',
      saveOk: 'Configuración guardada',
    },
    backfill: {
      title: 'Llenar etiquetado',
      mode: 'Modo',
      manual: 'Manual (por artículo)',
      batch: 'Trabajo en lote',
      scope: 'Alcance',
      scopeToTag: 'Solo pendientes',
      scopeAllPublished: 'Todos publicados',
      batchSize: 'Tamaño de lote',
      limit: 'Cantidad máxima',
      limitExtra: 'Solo llena artículos publicados y sin etiquetar, por defecto 200',
      gotoManual: 'Ir a Gestión de artículos',
      runBatch: 'Ejecutar llenado',
      batchOk: 'Trabajo de llenado disparado',
    },
  },

  articleType: {
    title: 'Gestión de categorías de artículos',
    addNew: 'Nueva categoría',
    createTitle: 'Nueva categoría',
    editTitle: 'Editar categoría',
    seoEditTitle: 'Configurar plantilla SEO',
    saveAndSeo: 'Guardar y configurar SEO',
    seoConfig: 'Configurar SEO',
    seoConfigured: 'Configurado',
    seoNotConfigured: 'No configurado',
    tplVarHint: 'Variables de plantilla disponibles: {categoryName} {total} {currentYear} {latestUpdate}',
    actions: {
      edit: 'Editar',
      seo: 'Plantilla SEO',
      delete: 'Eliminar',
      confirmDelete: '¿Está seguro de que desea eliminar esta categoría?',
        confirmDeleteName: '¿Está seguro de que desea eliminar categoría "{name}"?',
},
    form: {
      keyword: 'Nombre de categoría',
      keywordPlaceholder: 'Buscar nombre de categoría',
      language: 'Idioma',
      languagePlaceholder: 'Seleccione idioma',
      isActive: 'Estado',
      isActivePlaceholder: 'Seleccione estado',
      seoConfigured: 'Configuración SEO',
      sortBy: 'Ordenar por',
      sortByManual: 'Manual',
      sortByArticleCount: 'Artículos desc.',
      sortByUpdateTime: 'Actualizado recientemente',
      languageRequired: 'Seleccione idioma',
      parent: 'Categoría padre',
      parentPlaceholder: 'Seleccione categoría padre (opcional)',
      name: 'Nombre de categoría',
      namePlaceholder: 'Ingrese nombre de categoría',
      nameRequired: 'Ingrese nombre de categoría',
      slug: 'URL',
      slugPlaceholder: 'Identificador único, ruta de URL',
      slugFormat: 'URL permite solo letras minúsculas, dígitos e guiones',
      seoKeywords: 'Palabras clave meta',
      seoKeywordsPlaceholder: 'Separadas por comas (ignoradas por Google; opcional)',
      slugRequired: 'Ingrese URL',
      description: 'Descripción',
      descriptionPlaceholder: 'Ingrese descripción de categoría',
      descPlaceholder: 'Ingrese descripción de categoría (opcional)',
      sortOrder: 'Orden de clasificación',
      sortOrderPlaceholder: 'Número más bajo = posición más alta',
      seoTitleTpl: 'Plantilla de título SEO',
      seoTitleTplPlaceholder: 'ej. {categoryName} Guía {currentYear} | {total} Artículos',
      seoDescTpl: 'Plantilla de meta descripción',
      seoDescTplPlaceholder: 'ej. Explore {total} artículos de {categoryName}, última actualización {latestUpdate}',
      schemaType: 'Tipo de esquema',
      schemaTypePlaceholder: 'Seleccione tipo de esquema',
      hreflangList: 'Asociación de Hreflang',
      hreflangListPlaceholder: 'ej. en-US:/en/category/xxx,zh-CN:/zh/category/xxx',
    },
    table: {
      name: 'Nombre de categoría',
      language: 'Idioma',
      articleCount: 'Artículos',
      seoTemplate: 'Plantilla SEO',
      sortOrder: 'Orden',
      isActive: 'Estado',
      updateTime: 'Actualizado en',
      action: 'Acciones',
    },
    stats: {
      total: 'Categorías totales',
      languages: 'Idiomas',
      articles: 'Artículos totales',
      seoRate: 'Tasa SEO',
      languageUnit: 'idioma(s)',
      articleUnit: 'artículo(s)',
      balance: 'Balance de plataforma',
      balanceTip: 'Categorías activas con artículos / Categorías totales',
    },
    tabs: {
      basic: 'Información básica',
      seoTemplate: 'Plantilla SEO',
    },
    schema: {
      collectionPage: 'CollectionPage',
      itemList: 'ItemList',
    },
    seo: {
      metaDescPreviewPlaceholder: 'Meta descripción aparecerá aquí…',
      serpPreview: 'Vista previa de SERP',
    },
  },

  keyWordCenter: {
    importSuccess: "Importados {success} correctamente, {fail} fallaron",
    importEmpty: "No se detectaron datos válidos, verifique el formato",
    importLangMismatch: "filas con intención/prioridad/idioma no reconocidos — el CSV puede haber sido exportado en otra interfaz de idioma; cámbiese a ella e reintente",
    exportEmpty: "Sin datos bajo el filtro actual",
    exportSuccess: "Exportadas {count} palabras clave",
    title: 'Centro de inteligencia de palabras clave',
    addNew: 'Añadir palabra clave',
    createTitle: 'Añadir palabra clave',
    editTitle: 'Editar palabra clave',
    batchImport: 'Importación en lote',
    batchDelete: 'Eliminar en lote',
    confirmBatchDelete: '¿Está seguro de que desea eliminar las palabras clave seleccionadas?',
    selectRows: 'Seleccione palabras clave primero',
    importTitle: 'Importación en lote de palabras clave',
    importHint: 'Una palabra clave por línea, formato: palabra clave | intención | idioma | prioridad | volumen mensual',
    importPlaceholder: 'palabra clave | intención | idioma | prioridad | volumen mensual\ncasino en línea Filipinas | transaccional | es-419 | alta | 12400',
    importFormatHint: 'Soporta separadores coma, barra vertical o tabulación. También puede subir un CSV exportado (encabezado detectado automáticamente; columnas estado / artículos generados / tiempo de actualización se ignoran). Las palabras clave existentes se omitirán automáticamente.',
    intent: {
        informational: 'Informativo', info: 'Informativo',
        navigational: 'Navegacional', nav: 'Navegacional',
        transactional: 'Transaccional', trans: 'Transaccional',
        commercial: 'Comercial', comm: 'Comercial',
      },
    confirmStatus: {
      PENDING: 'Pendiente',
      CONFIRMED: 'Confirmado',
      REJECTED: 'Rechazado',
    },
    volumeSource: {
      gsc: 'GSC',
      dataforseo: 'DataForSEO',
      manual: 'Manual',
      unknown: 'Desconocido',
    },
    volumeSourceGscNote: 'impresiones',
    volumeStale: 'anticuado',
    generate: {
      disabledNotConfirmed: 'Confirme la intención antes de generar un artículo',
      disabledIsTypo: 'Palabra clave con error — use Combinar en lugar de generar',
      disabledIsNav: 'Palabra clave navegacional apunta a página de función — no se generó artículo',
    },
    confirmIntentTitle: 'Confirmar intención',
    confirmIntentDesc: 'Confirme la intención de búsqueda para esta palabra clave:',
    confirmIntentSuccess: 'Intención confirmada',
    confirmNoEffect: 'Sin cambios aplicados: la palabra clave puede ya estar confirmada/rechazada o falló la validación backend; actualice e reintente',
    merge: {
      title: 'Combinar palabra clave con error',
      targetKeyword: 'Palabra clave objetivo dataPkCode',
      targetPageUrl: 'URL de página de destino',
      success: 'Combinada',
    },
    priority: {
        high: 'Alta',
        medium: 'Media',
        low: 'Baja',
      },
    // Backend intent dict intentCode → localized display label (display only; intentCode is still sent to backend)
    intentByCode: {
      informational: 'Informativo', info: 'Informativo',
      navigational: 'Navegacional', nav: 'Navegacional',
      transactional: 'Transaccional', trans: 'Transaccional',
      commercial: 'Comercial', comm: 'Comercial',
      comparison: 'Comparación',
      howto: 'Cómo hacer',
      localQuery: 'Consulta local',
      news: 'Noticias',
      question: 'P&R',
    },
    coverage: {
      covered: 'Cubierto',
      uncovered: 'Sin cubrir',
    },
    actions: {
      edit: 'Editar',
      generate: 'Generar artículo',
      confirmIntent: 'Confirmar intención',
      mergeTo: 'Combinar con',
      archive: 'Archivar',
      restore: 'Restaurar',
      delete: 'Eliminar',
      confirmDelete: '¿Está seguro de que desea eliminar esta palabra clave?',
      confirmArchive: '¿Está seguro de que desea archivar esta palabra clave?',
      confirmRestore: '¿Está seguro de que desea restaurar esta palabra clave?',
        quickConfirm: '✓ Confirmar',
},
    form: {
      keyword: 'Palabra clave',
      keywordPlaceholder: 'Buscar palabras clave...',
      language: 'Idioma',
      languagePlaceholder: 'Seleccione idioma',
      intent: 'Intención de búsqueda',
      intentPlaceholder: 'Seleccione intención',
      intentDictHint: 'Opcional — controlado por diccionario de intención de 9 clases; puede confirmarse más tarde',
      confirmStatusPlaceholder: 'Estado de confirmación',
      priority: 'Prioridad',
      priorityPlaceholder: 'Seleccione prioridad',
      coverageStatus: 'Cobertura',
      coveragePlaceholder: 'Seleccione estado de cobertura',
      name: 'Palabra clave',
      nameRequired: 'Ingrese palabra clave',
      namePlaceholder: 'ej. casino en línea Filipinas',
      monthlyVolume: 'Volumen mensual',
      monthlyVolumePlaceholder: 'Volumen de búsqueda mensual estimado',
      intentRequired: 'Seleccione intención de búsqueda',
      intentDesc: {
        info:  'El usuario busca información o respuestas, ej. "cómo elegir un casino en línea"',
        nav:   'El usuario busca un sitio o marca específica, ej. "inicio de sesión oficial [Su marca]"',
        trans: 'El usuario tiene intención clara de registro o depósito, ej. "bono de registro casino"',
        comm:  'El usuario está comparando productos o servicios, ej. "mejor ranking de casino en línea Filipinas"',
      },
      remark: 'Notas',
      remarkPlaceholder: 'Opcional, añada contexto de palabra clave',
        volumeSource: 'Fuente de volumen',
    volumeSourcePlaceholder: 'Seleccione fuente de volumen',
},
    table: {
      keyword: 'Palabra clave',
      intent: 'Intención',
      confirmStatus: 'Estado de confirmación',
      priority: 'Prioridad',
      language: 'Idioma',
      monthlyVolume: 'Vol. mensual',
      coveredArticleCount: 'Artículos generados',
      coverageStatus: 'Cobertura',
      relatedArticles: 'Artículos',
      updateTime: 'Actualizado en',
      articles: 'artículos',
      action: 'Acciones',
        searchIntent: 'Intención de búsqueda',
},
    stats: {
      total: 'Palabras clave totales',
      active: 'Activas',
      weeklyNew: 'Nuevas esta semana',
      archived: 'Archivadas',
      covered: 'Artículos cubiertos',
      highPriority: 'Prioridad alta',
      avgVolume: 'Volumen mensual promedio',
      avgVolumeEmpty: 'Sin datos',
      avgVolumeBasis: 'Promedio calculado de {n} de {m} palabras clave que tienen datos de volumen de búsqueda',
      avgVolumeLowSample: 'muy pocas palabras clave tienen datos — el promedio no es confiable',
      thisWeek: 'esta semana',
      coverageRate: 'Cobertura',
      needCover: 'necesitan cobertura',
        pendingConfirm: 'Pendiente de confirmación de alta prioridad',
    generatable: 'Generatable',
    coveredArticles: 'Artículos generados',
},
    exportCsv: 'Exportar CSV',
    importConfirm: 'Iniciar importación',
    importUploadText: 'Haga clic o arrastre archivo CSV para subir',
    importUploadHint: 'Soporta archivos .csv o .txt',
    selectedCount: '{count} seleccionados',
    statusActive: 'Activa',
    statusArchived: 'Archivada',
    pleaseSelectStatus: 'Seleccione estado',
    batchDeleteUnavailable: 'La API de eliminación en lote de palabras clave aún no está disponible, contacte al desarrollador backend',
    batchImportFailed: 'Error en llamada API de importación en lote de palabras clave, contacte al desarrollador backend',
    exportMaxLimitWarn: 'Los datos exceden {max} filas, solo se exportarán las primeras {max}',
    totalRows: 'Total {total}',
    keywordCol: 'Palabra clave',
    langDisplay: {
      'en-US': 'English',
      'zh-CN': '中文',
      'vi-VN': 'Tiếng Việt',
      'tl-PH': 'Filipino',
    },
    priorityFull: {
      high: 'Prioridad alta',
      medium: 'Prioridad media',
      low: 'Prioridad baja',
    },
    importPreview: 'Vista previa',
    importDone: 'Hecho',
    importConfirmWithCount: 'Confirmar ({count})',
    importParsing: 'Analizando...',
    importParsedCount: 'Analizadas {count} filas',
    importReupload: 'Resubir',
    importStatusCol: 'Resultado de importación',
    importSelectAll: 'Seleccionar todos',
    importDeselectAll: 'Deseleccionar todos',
    importSuccessCount: '✅ {count} exitosas',
    importFailCount: '❌ {count} fallidas',
    importExistSkipHint: 'Las palabras clave existentes se omitirán automáticamente.',
    importStatusSuccess: '✅ Éxito',
    miningReason: {
      duplicate: 'Palabra clave duplicada',
      keywordExist: 'La palabra clave ya existe',
      invalidKeyword: 'Palabra clave inválida',
      langNotSupported: 'Idioma no soportado',
      limitExceeded: 'Límite excedido',
    },
    aiMining: {
      btn: 'Minería con IA',
      title: 'Minería de palabras clave con IA',
      description: 'IA extraerá automáticamente palabras clave de cola larga relacionadas basadas en su palabra clave semilla y analizará la intención de búsqueda de cada término.',
      form: {
        seed: {
          label: 'Palabra clave semilla',
          extra: 'Ingrese una palabra clave central e IA generará variantes, términos de cola larga y palabras clave basadas en preguntas alrededor de ella',
        },
        directions: {
          label: 'Direcciones de minería',
          longTail: 'Variantes de cola larga (ej. "mejor casino en línea PH 2025")',
          qa: 'Palabras clave de preguntas (ej. "¿es legal el casino en línea en Filipinas?")',
          compare: 'Comparación (ej. "[Su marca] vs competidor")',
          geo: 'Regional (ej. "casino Manila", "casino Cebu")',
        },
        language: {
          label: 'Idioma objetivo',
          mixed: 'Mixto (Multilingüe)',
        },
        competition: {
          label: 'Competencia objetivo',
          extra: 'Los sitios nuevos deben dirigirse primero a palabras clave de baja competencia para obtener clasificaciones más rápido',
          all: 'Todos los niveles de competencia',
          low: 'Baja competencia (fácil de clasificar, bueno para sitios nuevos)',
          medium: 'Competencia media',
          high: 'Competencia alta',
        },
        count: {
          label: 'Cantidad de minería',
          fast: '10 palabras clave (Rápido)',
          recommended: '20 palabras clave (Recomendado)',
          deep: '30 palabras clave (Profundo)',
        },
      },
      action: {
        start: 'Iniciar minería con IA',
        add: 'Añadir al Centro de palabras clave',
        close: 'Cerrar',
      },
      loading: 'IA está analizando intención de búsqueda y palabras clave de cola larga...',
      result: {
        title: 'Resultados de minería',
        note: 'Los duplicados con palabras clave existentes han sido filtrados automáticamente. Seleccione los términos que desea añadir, luego haga clic en "Añadir al Centro de palabras clave".',
      },
      intent: {
        informational: 'Informativo', info: 'Informativo',
        navigational: 'Navegacional', nav: 'Navegacional',
        transactional: 'Transaccional', trans: 'Transaccional',
        commercial: 'Comercial', comm: 'Comercial',
      },
      competition: {
        low: 'Baja competencia (fácil de clasificar, bueno para sitios nuevos)',
        medium: 'Competencia media',
        high: 'Competencia alta',
      },
      competitionCol: 'Competencia',
      relevance: 'Relevancia',
      selected: '{count} palabras clave seleccionadas',
      countUnit: 'palabras clave',
      estimatedCost: 'Costo aprox.: ~',
      seedRequired: 'Ingrese una palabra clave inicial',
      directionRequired: 'Seleccione al menos 1 dirección de búsqueda',
      addSuccess: 'Se añadieron exitosamente {count} palabras clave',
      selectAll: 'Seleccionar todo',
      modelLabel: 'Modelo IA',
      modelRequired: 'Seleccione un modelo IA',
      modelPlaceholder: 'Seleccione modelo IA',
      addStatusCol: 'Estado de adición',
      addStatusSuccess: 'Éxito',
      addStatusFail: 'Fallo',
      addResultEmptyWarn: 'Falta información de resultado — actualice la lista para confirmar que las palabras clave se añadieron',
    },
      selectedRows: '{count} seleccionados',
    batchConfirmUnavailable: 'API de confirmación de intención en lote aún no disponible',
    batchConfirmIntent: 'Confirmar intención en lote',
    batchConfirmTitle: 'Confirmar intención en lote',
    batchConfirmNoPending: 'No hay palabras clave pendientes en la selección',
    batchConfirmNeedIntent: 'Establezca una intención para al menos una palabra clave',
    batchConfirmSuccess: 'Intenciones confirmadas',
    batchMergeTypo: 'Fusionar errores tipográficos en lote',
    batchMergeNoTypo: 'No hay palabras clave con errores tipográficos en la selección',
},

  score: {
      aiReworkBtn: "Reescritura con IA",
      submitOnlyDraft: "Solo los artículos en borrador pueden enviarse para revisión",
    title: 'Evaluador SEO/GEO',
    checkArticle: 'Seleccionar artículo',
    checkArticlePlaceholder: 'Seleccione un artículo para evaluar',
    startScore: 'Iniciar evaluación',
    checkUrl: 'Evaluar por URL',
    checkUrlPlaceholder: 'Ingrese URL del artículo',
    checkContent: 'Ingresar contenido manualmente',
    articleTitle: 'Título del artículo',
    articleTitlePlaceholder: 'Ingrese título del artículo',
    articleTitleRequired: 'Ingrese el título del artículo',
    articleContent: 'Contenido del artículo',
    articleContentPlaceholder: 'Pegue HTML del artículo o texto plano',
    articleContentRequired: 'Ingrese el contenido del artículo',
    targetKeyword: 'Palabra clave objetivo',
    targetKeywordPlaceholder: 'Ingrese la palabra clave objetivo',
    seoDescription: 'Meta descripción',
    seoDescriptionPlaceholder: 'Ingrese meta descripción',
    startCheck: 'Iniciar evaluación',
    checking: 'Evaluando...',
    totalScore: 'Puntuación total',
    seoScore: 'Puntuación SEO',
    geoScore: 'Puntuación GEO',
    level: {
      excellent: 'Publicable',
      good: 'Requiere optimización',
      warning: 'Requiere mejora',
      fail: 'Requiere revisión',
    },
    checkItem: {
      status: {
        pass: 'Aprobado',
        warn: 'Advertencia',
        fail: 'Fallo',
      },
    },
    seoGroup: 'Verificaciones SEO',
    geoGroup: 'Verificaciones GEO',
    suggestion: 'Sugerencia de optimización',
    noResult: 'Seleccione un artículo para iniciar la evaluación',
    tagSuggest: 'Sugerir',
    tagTip: 'Consejo',
    btnSubmit: 'Enviar para revisión',
    btnContinue: 'Continuar optimizando',
    btnEdit: 'Ir a editar',
    btnAIRegenerate: 'Regenerar con IA',
    btnRescore: 'Reevaluar',
    btnBackToEditor: 'Volver al editor',
    submitTooltipNoScore: 'Ejecute la evaluación primero',
    submitTooltipBelow80: 'Se requiere puntuación ≥ 70 para enviar revisión (actual {{score}})',
    submitSuccess: 'Enviado para revisión exitosamente',
    submitFail: 'Fallo en el envío, intente nuevamente',
    submitFailTransition: 'Fallo en la transición de estado — el artículo no puede enviarse en su estado actual',
    scoreFail: 'Fallo en la evaluación, intente nuevamente',
    scoreError: 'Error en la solicitud de evaluación, intente nuevamente',
    history: 'Historial de puntuaciones',
    historyEmpty: 'Sin historial de puntuaciones',
    pleaseSelectModel: 'Seleccione primero un modelo IA',
    pleaseSelectArticle: 'Seleccione primero un artículo',
    selectModelLabel: 'Seleccionar modelo IA',
    selectModelPlaceholder: 'Seleccionar modelo IA',
    articleSearchHint: 'Buscar por título',
    viewMore: 'Ver más',
    checks: {
      titleKeyword: 'El título contiene la palabra clave objetivo',
      metaDescLength: 'La longitud de la meta descripción es válida',
      headingStructure: 'La estructura de encabezados H2/H3 está completa',
      keywordDensity: 'La densidad de palabras clave es apropiada',
      internalLinks: 'Contiene enlaces internos',
      ogImage: 'La imagen OG está configurada',
      canonicalUrl: 'La URL canónica está configurada',
      faqModule: 'Contiene módulo de preguntas frecuentes',
      blufFormat: 'Formato BLUF (respuesta directa primero)',
      namedAuthor: 'Autor nombrado + Esquema de persona',
      neutralTone: 'Tono neutral y autoritario',
      comparisonTable: 'Contiene tabla de comparación',
      authorityData: 'Contiene afirmaciones autorizadas y datos',
      freshness: 'Actualización de contenido',
    },
      totalScoreFormula: 'Combinada = (SEO + GEO) / (70 + 70)',
    checkGroupMaxScore: '{{itemCount}} elementos · máx {{max}}',
    btnRegenWithIssues: 'Regenerar con problemas',
    regenTooltipNoScore: 'Ejecute la evaluación primero antes de regenerar',
    regenTooltipPassed: 'La puntuación ya cumple el umbral; la regeneración es opcional',
},
  aiGenerator: {
    reworkBanner: '🤖 Modo Reescritura con IA: reescribiendo "{title}" — hacer clic en Guardar borrador actualizará el artículo original',
    title: 'Generador de contenido con IA',
    cardTitle: 'Parámetros de generación',
    previewTitle: 'Vista previa de contenido',
    historyTitle: 'Historial de generación',
    historyCount: 'Últimas 10',
    startBtn: 'Iniciar generación con IA',
    saveDraft: 'Guardar borrador',
    saveDraftDone: 'Guardado (Borrador)',
    updateArticle: 'Actualizar artículo',
    goScoreBtn: 'Ir a evaluación',
    goScore: '📊 Evaluación',
    submitReview: '📤 Enviar revisión',
    submitReviewBtn: 'Enviar para revisión',
    emptyHint: 'Configure los parámetros y haga clic en "Generar con IA"',
    emptySubHint: 'IA generará un artículo completo optimizado para SEO + GEO',
    generating: 'IA está escribiendo...',

    reuseParams: 'Reutilizar parámetros',
    viewHistory: 'Ver',
    historyTip: '"Reutilizar parámetros": regenera usando la misma palabra clave, longitud, tono, etc. "Ver": vista previa del contenido generado anteriormente y guarda como borrador.',
    form: {
      keyword: 'Palabra clave objetivo',
      keywordRequired: 'Seleccione una palabra clave objetivo',
      keywordPlaceholder: 'Seleccione del centro de palabras clave...',
      customKeyword: 'O ingrese la palabra clave directamente',
      customKeywordPlaceholder: 'Ingrese palabra clave personalizada...',
      articleType: 'Tipo de artículo',
      author: 'Autor de línea de firma',
      authorRequired: 'Seleccione un autor de línea de firma',
      authorPlaceholder: 'Seleccione autor...',
      coverImageSize: 'Tamaño de imagen de portada',
      coverImageSizeRecommended: '(Recomendado, estándar OG)',
      language: 'Idioma',
      wordCount: 'Longitud del artículo',
      extraReq: 'Requisitos adicionales',
      extraReqPlaceholder: 'p. ej., enfatizar la autoridad de licencia PAGCOR...',
      secondaryKeywords: 'Palabras clave secundarias (3-5)',
      secondaryKeywordsPlaceholder: 'Seleccione del centro de palabras clave (múltiples)',
      longTailQuestions: 'Preguntas de cola larga (3-5)',
      longTailQuestionsPlaceholder: 'Una pregunta por línea',
      aiSuggestLongTailBtn: 'Sugerir con IA',
      aiSuggestLongTailNoKeyword: 'Seleccione primero una palabra clave objetivo',
      aiSuggestLongTailEmpty: 'No se devolvieron sugerencias de preguntas; ingrese manualmente',
      aiSuggestLongTailDisabledHint: 'API de sugerencia de IA aún no disponible; ingrese manualmente',
      mustInclude: 'Hechos que deben incluirse',
      mustIncludePlaceholder: 'Hechos que el artículo debe incluir',
      mustAvoid: 'Debe evitar',
      mustAvoidPlaceholder: 'Palabras/afirmaciones que el artículo debe evitar',
      targetWordCount: 'Recuento de palabras objetivo',
      wordsUnit: 'palabras',
      wordCountWarning: 'El recuento de palabras objetivo está fuera del rango recomendado para este tipo de contenido',
      presetApplied: 'Valores por defecto aplicados para el tipo de contenido seleccionado',
      relatedEntities: 'Entidades relacionadas',
      relatedEntitiesPlaceholder: 'Seleccione entidades relacionadas',
      entityTypeFilter: 'Tipo de entidad',
      entityTypeFilterPlaceholder: 'Filtrar por tipo',
      entityTypePerson: 'Persona',
      entityTypeOrganization: 'Regulador',
      entityTypeProduct: 'Juego',
      entityTypeConcept: 'Concepto',
      entityTypePlace: 'Lugar',
      entityTypeBrand: 'Marca',
      entityTypeEvent: 'Actividad',
      inlinkSuggest: 'Recomendar enlaces internos',
      inlinkSuggestBtn: 'Obtener sugerencias',
      inlinkSuggestEmpty: 'No se encontraron artículos candidatos',
      mustIncludeInlinks: 'Enlaces internos que deben incluirse',
      entityRelSaveError: 'Fallo al guardar relaciones de entidades, intente nuevamente',
      keywordIntent: {
        informational: 'Informativo',
        navigational: 'Navegacional',
        transactional: 'Transaccional',
      },
      keywordVolume: 'Volumen mensual',
      keywordCovered: 'Cubierto',
      keywordUncovered: 'No cubierto',
      switchKeywordTitle: 'Cambiar palabra clave objetivo',
      switchKeywordContent: '¿Generación en curso. ¿Cambiar la palabra clave la interrumpirá. Continuar?',
      contentType: 'Tipo de contenido',
      contentTypeRequired: 'Seleccione el tipo de contenido',
      contentTypePlaceholder: 'Seleccione tipo de contenido...',
      schemaType: 'Tipo de esquema',
      schemaTypePlaceholder: 'Seleccione tipo de esquema...',
      schemaTypeHint: 'Sugerido automáticamente por tipo de contenido; ajustable',
      geoMode: 'Modo GEO',
      geoModePlaceholder: 'Seleccione modo GEO...',
      modelCode: 'Modelo de artículo',
      modelCodePlaceholder: 'Seleccione modelo de generación de artículos',
      modelCodeRequired: 'Seleccione un modelo de generación de artículos',
      imageModelCode: 'Modelo de imagen de portada',
      imageModelCodePlaceholder: 'Seleccione modelo de imagen de portada (opcional)',
      imageModelCodeRequired: 'Seleccione un modelo de generación de imágenes de portada',
      imageModelCodeTip: 'Omitir para generar más rápido sin una imagen de portada',
      langSimplifiedChinese: 'Chino simplificado',
      category: 'Categoría de artículo',
      categoryPlaceholder: 'Seleccione categoría (opcional)',
      includeCitations: 'Incluir citas y enlaces externos',
      includeCitationsExtra: 'Incluye etiquetas de cita o enlaces externos para mejorar la puntuación de autoridad GEO',
      includeFaq: 'Incluir párrafos de preguntas frecuentes',
      includeFaqExtra: 'Contiene encabezados H2 de estilo pregunta-respuesta, mejora la puntuación de extracción de respuestas GEO',
      contentLength: 'Longitud del artículo',
      contentLengthShort: 'Corto (500-800 palabras)',
      contentLengthStandard: 'Estándar (1000-2000 palabras)',
      contentLengthLong: 'Largo (2500-4000 palabras)',
    },
    preview: {
      articleTitle: 'Título del artículo',
      articleTitleRequired: 'Ingrese el título del artículo',
      articleTitlePlaceholder: 'Ingrese título del artículo...',
      slug: 'Slug de URL',
      slugRequired: 'Ingrese slug de URL',
      slugPlaceholder: 'Generado automáticamente, puede modificarse',
      scoreDisabledTip: 'Guarde el borrador primero',
      submitDisabledNoScore: 'Complete primero la evaluación',
      submitDisabledLowScore: 'Puntuación por debajo del umbral requerido (se necesita ≥60)',
      summary: 'Resumen del artículo',
      summaryPlaceholder: 'Resumen de 2-3 oraciones del artículo...',
      ogTitle: 'Título OG',
      ogTitlePlaceholder: 'Predeterminado: igual que el título SEO',
      ogDescription: 'Descripción OG',
      ogDescriptionPlaceholder: 'Predeterminado: igual que la meta descripción',
      coverImage: 'Imagen de portada',
      coverImageHint: 'Recomendado: 1200×630px, JPG/PNG/WEBP, máx 2MB. También se usa como imagen OG.',
      aiGeneratedImage: 'Imagen de portada generada por IA',
      generateCoverImage: 'Generar imagen',
      regenerateCoverImage: 'Regenerar imagen',
      generatingImage: 'Generando imagen de portada...',
      imageGenOk: 'Imagen de portada generada exitosamente',
      imageGenEmpty: 'Fallo en la generación de imagen, intente nuevamente',
      regenerateImage: 'Regenerar imagen',
      regenerateImageSuccess: 'Imagen regenerada exitosamente',
      regenerateImageFailed: 'Fallo en la generación de imagen, intente nuevamente',
      coverImageUploadFail: 'Fallo al cargar imagen de portada, intente nuevamente',
      noTaskForImage: 'La generación de imágenes con IA no está disponible en modo reescritura, cargue manualmente',
      selectImageModelFirst: 'Seleccione primero un modelo de imagen',
        metaDescWarnHint: 'Acercándose al límite, considere acortar',
    metaDescOverHint: 'Excede el límite de 200 caracteres',
},
    articleType: {
      guide: '📖 Guía exhaustiva',
      review: '⭐ Reseña y comparación',
      news: '📰 Noticias',
      faq: '❓ Preguntas frecuentes',
    },
    wordCount: {
      standard: 'Estándar (1500-2000 palabras)',
      short: 'Corto (800-1200 palabras)',
      long: 'Largo (2500-3500 palabras)',
    },
    historyStatus: {
      draft: 'Borrador',
      published: 'Publicado',
      discarded: 'Descartado',
      pending_review: 'Pendiente de revisión',
    },
    historyCol: {
      time: 'Hora',
      keyword: 'Palabra clave objetivo',
      articleTitle: 'Título del artículo',
      model: 'Modelo',
      score: 'Puntuación',
      status: 'Estado',
      action: 'Acción',
        articleType: 'Tipo de contenido',
},
    steps: {
      config: 'Configurar',
      generate: 'Generar con IA',
      preview: 'Editar vista previa',
      score: 'Verificación de puntuación',
      submit: 'Enviar revisión',
    },
    genStep: {
      intent: 'Analizando palabras clave e intención de búsqueda',
      structure: 'Construyendo estructura de artículo y encabezados',
      content: 'Escribiendo contenido del cuerpo y secciones de preguntas frecuentes',
      meta: 'Generando campos meta SEO y OG',
      image: 'Generando imagen de portada',
    },
    generatingSteps: {
      intent: 'Analizando intención de búsqueda por palabra clave',
      research: 'Investigando contenido de competencia',
      content: 'Generando cuerpo optimizado para SEO',
      faq: 'Creando pares de preguntas frecuentes',
      meta: 'Generando etiquetas Meta',
      links: 'Recomendando enlaces internos',
    },
    geoSectionTitle: '🧠 Opciones de optimización GEO',
    generateError: 'Fallo en la generación',
    generateErrorFallback: 'Fallo en la generación con IA. Intente nuevamente.',
    retryBtn: 'Reintentar',
    articleTypeOpt: {
      deepGuide: '📖 Guía exhaustiva',
      review:    '⭐ Reseña y comparación',
      news:      '📰 Noticias',
      faq:       '❓ Preguntas frecuentes',
      tutorialGuide: '🎓 Tutorial',
      howto: '🎯 Guía de procedimientos',
      comparison: '⭐ Reseña y comparación',
      listicle: '📋 Artículo de lista',
      landingPage: '🛬 Página de destino',
      brand:     'Marca',
      brandTypo: 'Error tipográfico de marca',
      nav:       'Navegacional',
      trust:     '🛡️ Confianza / Legitimidad',
      tutorial:  'Tutorial',
      local:     '📍 Página de destino local',
      product:   '🎰 Página de producto / juego',
      event:     '🎁 Promoción / evento',
      info:      'Informativo',
    },
    geoModeOpt: {
      normal:           'Normal',
      normalDesc:       'Estructura de artículo estándar, adecuada para la mayoría del contenido',
      bluf:             'Formato BLUF (recomendado)',
      blufDesc:         'Resultado principal adelante — comienza con la respuesta, más fácil para que los motores de búsqueda de IA extraigan fragmentos',
      compareTable:     'Tabla de comparación',
      compareTableDesc: 'Presenta comparaciones lado a lado en tablas, ideal para reseñas de productos y guías de compra',
      qaCluster:        'Grupo de preguntas y respuestas',
      qaClusterDesc:    'Organiza el contenido como un grupo de pares de preguntas y respuestas',
      stepByStep:       'Paso a paso',
      stepByStepDesc:   'Instrucciones numeradas paso a paso, ideales para tutoriales/guías de procedimientos',
      notReady: 'Aún no soportado por el backend; próximamente',
    },
    stepName: {
      configParams: 'Analizar parámetros',
      aiGenerate:   'Generar con IA',
    },
    unknownStatus: 'Estado desconocido {code}, por favor contacte al administrador',
    pollingTimeout: 'Generación agotada. Sondeo detenido. Actualice e intente nuevamente.',
    cancelTaskBtn: 'Cancelar tarea',
    deleteTaskBtn: 'Eliminar',
    runScoreCheckBtn: 'Ejecutar verificación de puntuación',
    finalizeBtn: 'Finalizar',
    taskHistoryTab: 'Tareas de generación con IA',
    publishedArticlesTab: 'Artículos publicados',
    taskStatus: {
      created: 'Creado',
      generating: 'Generando',
      editing: 'Editando',
      reviewing: 'Bajo revisión',
      failed: 'Fallo',
      cancelled: 'Cancelado',
      finalized: 'Finalizado',
      unknown: 'Desconocido',
    },
    phase: {
      created: 'Pendiente',
      generating: 'Generando',
      editing: 'Listo',
      reviewing: 'Revisando',
      finalized: 'Finalizado',
      failed: 'Fallo',
      cancelled: 'Cancelado',
      unknown: 'Desconocido',
    },
    msg: {
      saveDraftOk: 'Guardado como borrador. Búsquelo en Administración de artículos.',
      saveDraftFirst: 'Guarde como borrador primero antes de enviar para revisión.',
      submitReviewConfirmTitle: 'Enviar para revisión',
      submitReviewConfirmContent: '¿Enviar este artículo para revisión?',
      submitReviewDisabledHint: 'Alcance la puntuación requerida antes de enviar para revisión',
      scoreFirst: 'Complete la puntuación SEO/GEO (≥80) antes de enviar para revisión.',
      submitReviewOk: 'Enviado para revisión exitosamente.',
      viewPending: 'Ver contenido histórico (API pendiente)',
      reuseOk: 'Parámetros reutilizados. Reconfiguración y genere nuevamente.',
      submitReviewFieldsMissing: 'Fallo al enviar revisión: faltan campos requeridos. Verifique título y contenido.',
      pkCodeLookupFailed: 'Tarea creada pero no se pudo resolver la ID de tarea. Actualice e intente nuevamente.',
      articleIdMissing: 'Artículo guardado, pero no se pudo obtener la ID del artículo. Actualice y continúe editando.',
      cancelOk: 'Tarea cancelada.',
      deleteOk: 'Tarea eliminada.',
      finalizeOk: 'Finalizado. Encuentre el artículo en Administración de artículos.',
      cancelConfirmTitle: '¿Cancelar esta tarea de generación?',
      deleteConfirmTitle: '¿Eliminar esta tarea de generación? Esta acción no se puede deshacer.',
      scoreCheckStarted: 'Verificación de puntuación iniciada.',
      contentSyncFailed: 'Fallo en la sincronización de contenido. Guarde manualmente.',
      statusTransitionIllegal: 'Esta acción no se admite en el estado actual.',
      noTaskForSubmit: 'No se encontró tarea asociada. Genere primero un artículo a través de IA.',
    },
  },
  siteLink: {
    title: 'Enlaces internos',
    addBtn: 'Añadir regla',
    cardTitle: 'Reglas de enlaces internos',
    tip: 'Los enlaces se inyectan automáticamente durante la representación SSR. Los enlaces manuales existentes en artículos no se duplican. Las reglas se pausan automáticamente cuando la URL de destino se desconecta.',
    deleteOk: 'Regla eliminada',
    offlineTip: 'Destino fuera de línea',
    hitCountLabel: 'Impactó {n} artículos',
    stat: {
      total: 'Total de reglas',
      enabledRules: 'Habilitado',
      hitArticles: 'Artículos impactados',
      totalHits: 'Total de impactos',
    },
    col: {
      ruleName: 'Nombre de regla',
      keyword: 'Palabra clave',
      targetUrl: 'URL de destino',
      lang: 'Idioma',
      hitArticles: 'Artículos impactados',
      lastHit: 'Último impacto',
      status: 'Estado',
      action: 'Acción',
    },
    drawer: {
      title: 'Detalles de impacto',
      articleId: 'ID del artículo',
      hitCount: 'Impactos',
      lastHit: 'Último impacto',
      action: 'Acción',
      viewArticle: 'Ver artículo',
      empty: 'Ningún artículo ha activado esta regla todavía',
    },
    statusLabel: {
      enabled: 'Habilitado',
      disabled: 'Pausado',
    },
    edit: {
      createTitle: 'Añadir regla de enlace interno',
      editTitle: 'Editar regla de enlace interno',
      ruleName: 'Nombre de regla',
      ruleNameRequired: 'Ingrese un nombre de regla',
      ruleNamePlaceholder: 'p. ej.: enlace de guía de licencia PAGCOR',
      lang: 'Idioma',
      langRequired: 'Seleccione un idioma',
      langPlaceholder: 'Seleccionar idioma',
      sourcePattern: 'Palabra clave / patrón de activación',
      sourcePatternRequired: 'Ingrese una palabra clave o patrón de activación',
      sourcePatternPlaceholder: 'p. ej.: licencia PAGCOR',
      keywordExtra: 'Cuando esta palabra clave aparezca en el cuerpo del artículo, se convertirá automáticamente en un enlace. No distingue mayúsculas/minúsculas.',
      targetUrl: 'URL de destino',
      targetUrlRequired: 'Ingrese una URL de destino',
      targetUrlPlaceholder: 'p. ej.: /article/pagcor-casino-guide',
      targetUrlExtra: 'Debe ser una URL interna que comience con /',
      anchorText: 'Texto de ancla',
      anchorTextPlaceholder: 'Predeterminado: usa la palabra clave en sí',
      matchType: 'Tipo de coincidencia',
      matchTypeExtra: 'Exacto: coincide solo con la palabra exacta. Contiene: coincide con cualquier aparición. Expresión regular: usa expresiones regulares.',
      exactMatch: 'Coincidencia exacta — solo palabra exacta (recomendado)',
      containsMatch: 'Coincidencia de contiene — coincide con texto parcial',
      regexMatch: 'Coincidencia de expresión regular — usa expresión regular',
      maxPerPage: 'Máximo de reemplazos por página',
      maxLinksExtra: 'Máximo de enlaces generados para la misma palabra clave en un artículo. Usualmente 1 es suficiente.',
      priority: 'Prioridad',
      priorityTooltip: 'Mayor prioridad (número mayor) significa que la regla se coincide primero. Cuando múltiples reglas tienen palabras clave superpuestas, las reglas de mayor prioridad entran en efecto primero. Las frases largas/exactas deben tener mayor prioridad.',
      status: 'Estado',
      statusEnabled: 'Habilitado',
      statusDisabled: 'Pausado',
      saveOk: 'Regla actualizada',
      createOk: 'Regla creada',
      regexConfirmTitle: '¿Usar coincidencia de expresión regular?',
      regexConfirmContent: 'La expresión regular inválida puede romper la representación de página. Asegúrese de entender la sintaxis de expresión regular.',
      lockedTooltip: 'Para cambiar idioma o tipo de coincidencia, elimine esta regla y cree una nueva',
      applyScopeWarning: 'Esta regla se aplica a todos los artículos publicados del idioma seleccionado. El alcance por categoría o artículos excluidos no se admite.',
      advancedSettings: 'Configuración avanzada',
      priorityHigh: 'Alta (coincide primero)',
      priorityMedium: 'Medio (predeterminado)',
      priorityLow: 'Bajo',
      articlePickerLabel: 'Seleccionar de artículos publicados (opcional)',
      articlePickerPlaceholder: 'Buscar título del artículo',
      articlePickerNeedLang: 'Seleccione idioma primero',
      articlePickerExtra: 'Seleccionar un artículo rellena la URL de destino arriba',
      conflictTitle: 'Conflicto de palabra clave detectado',
      conflictDesc: 'La nueva regla contiene o está contenida por estas reglas existentes. La regla de mayor prioridad gana en la coincidencia. ¿Continuar?',
    },
    frm: {
      keyword: 'Palabra clave',
      keywordPlaceholder: 'Buscar palabra clave o URL...',
      ruleName: 'Nombre de regla',
      ruleNamePlaceholder: 'Buscar por nombre de regla...',
      status: 'Estado',
      statusAll: 'Todos los estados',
      lang: 'Idioma',
      langPlaceholder: 'Todos los idiomas',
    },
      deleteConfirmTitle: 'Confirmar eliminación',
    deleteConfirmContent: 'Esta acción no se puede deshacer. La regla y todos los datos relacionados se eliminarán permanentemente.',
    deleteConfirmOk: 'Eliminar',
},
  siteMap: {
    status: {
      included: 'Incluido',
      waiting: 'Pendiente',
      excluded: 'Excluido',
    },
    title: 'Administración de mapa del sitio',
    regenBtn: 'Regenerar',
    viewXmlBtn: 'Ver XML',
    viewAuthorsXmlBtn: 'XML de autores',
    authorsXmlPending: 'API de backend pendiente',
    syncAuthorTip: 'Sincronizar páginas de autores en el mapa del sitio, luego previsualizar XML',
    syncAuthorOk: 'Páginas de autores sincronizadas',
    regenOk: 'Mapa del sitio regenerado',
    cardTitle: 'Configuración de inclusión de ruta',
    xmlModalTitle: 'Vista previa de sitemap.xml',
    toggleFail: 'Acción fallida, revertida',
    addBtn: 'Añadir URL',
    xmlEmpty: 'Haga clic en "Ver XML" para generar',
    xmlLoading: 'Generando…',
    frm: {
      pageType: 'Tipo de página',
      lang: 'Idioma',
      localIndexStatus: 'Estado del índice',
    },
    col: {
      path: 'Patrón de ruta',
      pageUrl: 'URL de página',
      type: 'Tipo',
      pageType: 'Tipo de página',
      lang: 'Idioma',
      include: 'Incluir',
      localIndexStatus: 'Estado del índice',
      changefreq: 'Frecuencia de actualización',
      priority: 'Prioridad',
      action: 'Acciones',
    },
    edit: {
      titleNew: 'Añadir URL del mapa del sitio',
      titleEdit: 'Editar URL del mapa del sitio',
      pageTypeRequired: 'Seleccione tipo de página',
      pageTypePlaceholder: 'Seleccionar tipo de página',
      pageUrlRequired: 'Ingrese URL de página',
      pageUrlInvalid: 'Ingrese una URL válida (ruta relativa como /article/slug o URL completa como https://example.com/page)',
      pageUrlPlaceholder: '/article/my-slug or https://example.com/page',
      langRequired: 'Seleccione idioma',
      langPlaceholder: 'Seleccionar idioma',
      includeInSitemap: 'Incluir en sitemap.xml',
      includeInSitemapHint: 'Solo las páginas con estado "Incluido" se generan en sitemap.xml',
    },
    stat: {
      total: 'Total de páginas',
      indexed: 'Indexado',
      pending: 'Índice pendiente',
      excluded: 'Excluido',
    },
    pageType: {
      home:     'Inicio',
      article:  'Artículo',
      category: 'Categoría',
      login:    'Iniciar sesión',
      author:   'Autor',
      template: 'Plantilla',
    },
    freq: {
      always: 'Siempre',
      hourly: 'Cada hora',
      daily: 'Diario',
      weekly: 'Semanal',
      monthly: 'Mensual',
      yearly: 'Anual',
      never: 'Nunca',
    },
    xmlModal: {
      urlLabel: 'URL: ',
      copyBtn: 'Copiar',
      copyOk: 'Copiado al portapapeles',
      indexFileLabel: '{file} (índice de mapa del sitio · agrega mapas del sitio por idioma)',
      langFileLabel: '{file} (sub-mapa del sitio {lang})',
      copyFail: 'Fallo al copiar',
      lastGenLabel: 'Generado por última vez: ',
      openNewTab: 'Abrir /sitemap.xml en nueva pestaña',
      closeBtn: 'Cerrar',
    },
    statDesc: {
      title: 'Referencia de métricas',
      total: 'Total de URLs del mapa del sitio generadas realmente por el servidor SSR, incluyendo todos los patrones de ruta habilitados.',
      indexed: 'Desde Google Search Console API, sincronizado diariamente — páginas que Google ya ha indexado.',
      pending: 'Total de páginas menos indexadas — enviadas pero aún no procesadas por Google.',
      excluded: 'Desde Google Search Console — páginas excluidas por etiquetas noindex o reglas de robots.',
      gscTip: 'Los datos indexados y excluidos requieren integración de Google Search Console API. Muestra — cuando no está conectado.',
    },
  },
  declDoc: {
    title: 'Archivos de declaración del sitio',
    robotsTab: 'robots.txt',
    llmsTab: 'llms.txt',
    save: 'Guardar',
    saveOk: 'Guardado',
    saveFailed: 'Fallo al guardar',
    publish: 'Publicar',
    publishOk: 'Publicado exitosamente',
    publishFailed: 'Fallo al publicar',
    robotsDesc: 'Controla el acceso del motor de búsqueda y el rastreador de IA. Use los interruptores a la derecha para un control rápido del rastreador de IA.',
    advancedWarn: '⚠️ Modo avanzado: las reglas de robots incorrectas pueden bloquear todo su sitio. Verifique la sintaxis antes de guardar.',
    llmsDesc: 'Un archivo de descripción del sitio para motores de IA. Indica a IA de qué trata su sitio y cómo citarlo.',
    botSwitchTitle: 'Interruptores rápidos de rastreador de IA',
    botTip: '💡 GEO requiere permitir rastreadores de IA. Deshabilitar evitará que ese motor de IA cite sus artículos.',
    siteUrlInvalid: 'Ingrese un dominio de sitio válido (p. ej. https://example.com)',
    siteUrlLabel: 'Dominio del sitio',
    siteUrlHint: 'Se usa para la línea de mapa del sitio robots.txt y las URL de artículos llms.txt (compartidas entre pestañas)',
    brandNameLabel: 'Nombre de marca',
    brandNamePlaceholder: 'p. ej. [Su marca]',
    taglineLabel: 'Eslogan',
    taglinePlaceholder: 'p. ej. casino en línea con licencia PAGCOR',
    statusPublished: 'Publicado',
    statusDraft: 'Borrador',
    saveAndPublish: 'Guardar y publicar',
    robotsInfoBanner: 'Alternar acceso del rastreador de IA; surte efecto en robots.txt después de guardar y publicar',
    brandIntroLabel: 'Introducción de marca',
    brandIntroPlaceholder: '2-3 oraciones sobre el posicionamiento de su marca, licencia, servicios principales',
    guidesAutoTitle: 'Guías (generadas automáticamente a partir de artículos publicados en este idioma)',
    guidesEmpty: 'Sin artículos {lang} publicados',
    guidesLangName: { 'en-US': 'English', 'zh-CN': 'Chinese', 'vi-VN': 'Vietnamese', 'tl-PH': 'Filipino' },
    guidesError: 'Fallo al cargar artículos',
    previewTitle: 'Vista previa en vivo',
    langLoadFail: 'Fallo al cargar la lista de idiomas (posible problema de permisos entre módulos); se recurrió al idioma predeterminado. Por favor, pida al backend que verifique el permiso de API de administración multilingüe.',
      historyBtn: 'Historial',
    historyDrawerTitle: 'Historial de versiones',
    historyColVersion: 'Versión',
    historyColStatus: 'Estado',
    historyColTime: 'Hora',
    historyColAction: 'Acción',
    historyEmpty: 'Sin historial de versiones',
    historyLoadFailed: 'Fallo al cargar historial',
    historyNoContent: '(sin contenido)',
    rollbackBtn: 'Revertir',
    rollbackConfirmTitle: 'Confirmar reversión',
    rollbackConfirmContent: '¿Esto restaurará la versión seleccionada como el nuevo borrador. Continuar?',
    rollbackConfirmOk: 'Confirmar',
    rollbackConfirmCancel: 'Cancelar',
    rollbackOk: 'Revertido exitosamente',
    rollbackFailed: 'Fallo de reversión',
    llmsInfoBanner: 'llms.txt ayuda a los rastreadores de IA a entender tu marca y citar tu contenido con precisión.',
},
  health: {
    title: 'Verificación de Salud SEO',
    rescanBtn: '🔄 Rescan',
    scanNowBtn: 'Ejecutar Escaneo',
    emptyHint: 'Sin captura aún. Ejecuta el primer escaneo para rellenar datos.',
    scanOk: 'Escaneo completado. Puntuación: ',
    scanFailed: 'Escaneo fallido',
    scanResultEmpty: 'El escaneo no devolvió datos, intenta más tarde',
    loadFailed: 'Fallo al cargar',
    resolveOk: 'Marcado como resuelto',
    resolveFailed: 'Acción fallida',
    scanTimeLabel: 'Último Escaneo',
    contentFreshnessLabel: 'Frescura',
    authorCoverageLabel: 'Cobertura de Autor',
    schemaLabel: 'Esquema',
    crawlerAccessLabel: 'Acceso del Rastreador',
    severityHigh: 'alto',
    severityMedium: 'medio',
    severityLow: 'bajo',
    resolvedTag: 'resuelto',
    allHealthy: 'Todas las verificaciones pasaron 🎉',
    noIssues: 'Sin problemas',
    staleCard: 'Frescura de Contenido',
    staleCount: 'expirado',
    staleDesc: 'A la IA le prefiere contenido <13 semanas antiguo. Artículos no actualizados en 90+ días necesitan refresco.',
    staleModalTitle: 'Artículos Antiguos',
    staleModalClose: 'Cerrar',
    authorCard: 'Cobertura de Autor',
    authorDesc: 'E-E-A-T requiere que cada artículo tenga un autor en firma + Person Schema.',
    authorManageBtn: 'Gestionar Autores >',
    unsignedViewBtn: 'Ver Artículos Sin Firma >',
    unsignedModalTitle: 'Artículos Publicados Sin Firma',
    unsignedAssignBtn: 'Asignar Autor',
    unsignedEmpty: 'Todos los artículos publicados tienen autores',
    schemaCard: 'Cobertura de Esquema',
    schemaDesc: 'SSR inyecta automáticamente datos estructurados. Enfócate en artículos sin info de autor.',
    cwvCard: 'Core Web Vitals',
    cwvDesc: 'Fuente: Google PageSpeed Insights (PSI), datos de usuarios reales de los últimos 28 días.',
    cwvWaitingPsi: 'Fuente PSI pendiente',
    col: {
      target: 'Objetivo',
      severity: 'Severidad',
      action: 'Acción',
      articleTitle: 'Título',
      publishTime: 'Publicado',
    },
    actionEdit: 'Editar',
    actionAiRefresh: 'Refresco por IA',
    actionMarkResolved: 'Marcar Resuelto',
    cwv: {
      lcp: 'LCP (Largest Contentful Paint)',
      inp: 'INP (Interaction to Next Paint)',
      cls: 'CLS (Cumulative Layout Shift)',
      lcpHint: 'Bueno < 2.5s',
      inpHint: 'Bueno < 200ms',
      clsHint: 'Bueno < 0.1',
      ratingGood: 'Bueno',
      ratingNeedsImprovement: 'Necesita Mejora',
      ratingPoor: 'Pobre',
      ratingUnknown: '—',
    },
      actionReopen: 'Reabrir',
    reopenOk: 'Problema reabierto',
    reopenFailed: 'Fallo al reabrir',
    schemaModalTitle: 'Problemas de Cobertura de Esquema',
    showResolved: 'Mostrar resueltos',
},
  pageModel: {
    pageType: {
      home: 'Inicio',
      login: 'Acceso',
      news: 'Lista de Artículos',
      'news-category': 'Categoría de Artículos',
      loading: 'Página de Destino',
      'authors-list': 'Lista de Autores',
    },
    title: 'Plantillas SEO de Página',
    addBtn: '+ Nueva SEO de Página',
    cardTitle: 'Plantillas SEO de Página',
    alertTip: 'Gestiona info Meta SEO para páginas fijas (Inicio, VIP, Promo, etc.). Cada página se configura independientemente por idioma. SEO de Artículos se configura en Gestión de Artículos.',
    allConfiguredTip: 'Todas las páginas fijas ya están configuradas',
    notSet: 'No Establecido',
    ogMissing: 'Sin OG',
    missingDesc: 'Sin Descripción',
    editBtn: 'Editar',
    deleteBtn: 'Eliminar',
    deleteConfirm: '¿Estás seguro de que deseas eliminar esta plantilla?',
    deleteOk: 'Plantilla eliminada exitosamente.',
    deleteError: 'Fallo al eliminar plantilla. Por favor, intenta de nuevo.',
    loadError: 'Fallo al cargar datos. Por favor, intenta de nuevo.',
    emptyText: 'No se encontraron plantillas SEO de página',
    toggleError: 'Fallo al actualizar estado. Cambio revertido.',
    frm: {
      keyword: 'Búsqueda',
      keywordPlaceholder: 'Buscar nombre de página',
      pageKey: 'Clave de Página',
      pageKeyPlaceholder: 'Buscar por clave de página (slug)',
      language: 'Idioma',
      languagePlaceholder: 'Seleccionar idioma',
      pageType: 'Tipo de Página',
      pageTypePlaceholder: 'Seleccionar tipo de página',
      status: 'Estado',
      statusPlaceholder: 'Seleccionar estado',
      statusEnabled: 'Habilitado',
      statusDisabled: 'Deshabilitado',
    },
    col: {
      pageName: 'Nombre de Página',
      pageKey: 'Clave de Página',
      language: 'Idioma',
      titleDesc: 'Título SEO / Descripción',
      og: 'OG',
      robots: 'Robots',
      enabled: 'Habilitado',
      action: 'Acción',
    },
    edit: {
      createTitle: 'Nueva Plantilla SEO de Página',
      editTitlePrefix: 'Editar SEO de Página — ',
      pageType: 'Tipo de Página',
      pageTypeRequired: 'Por favor, selecciona un tipo de página',
      pageTypePlaceholder: 'Seleccionar tipo de página',
      pageTypeExtra: 'No se puede cambiar después de la creación',
      language: 'Idioma',
      languageExtra: 'No se puede cambiar después de la creación',
      seoTitle: 'Título SEO',
      seoTitleExtra: 'Se recomienda 50-60 caracteres, soporta variables: {platform} {currentYear}',
      seoTitlePlaceholder: 'Ingresa el título SEO mostrado en resultados de búsqueda',
      seoTitleRequired: 'Por favor, ingresa Título SEO',
      metaDesc: 'Meta Descripción',
      metaDescExtra: 'Se recomienda 100-160 caracteres',
      metaDescPlaceholder: 'Ingresa la meta descripción mostrada en resultados de búsqueda',
      metaDescRequired: 'Por favor, ingresa Meta Descripción',
      canonical: 'URL Canónica',
      canonicalPlaceholder: 'https://example.com',
      canonicalExtra: "URL Canónica. SSR inyecta automáticamente <link rel='canonical'>",
      canonicalInvalid: 'Por favor, ingresa una URL válida (ej. https://example.com)',
      pageName: 'Nombre de Visualización de Página',
      pageNameRequired: 'Por favor, ingresa un nombre de visualización de página',
      pageNamePlaceholder: 'ej. Inicio, VIP, Promociones',
      langRequired: 'Por favor, selecciona un idioma',
      metaKeywords: 'Meta Palabras Clave',
      metaKeywordsPlaceholder: 'Palabras clave separadas por comas',
      loadError: 'Fallo al cargar datos de plantilla.',
      ogSync: 'Sincronizar Título / Descripción SEO',
      ogTitle: 'Título OG',
      ogTitlePlaceholder: 'Dejar en blanco para usar Título SEO',
      ogDesc: 'Descripción OG',
      ogDescPlaceholder: 'Dejar en blanco para usar Meta Descripción',
      ogSection: 'Compartir en Redes Sociales (Open Graph)',
      ogImage: 'Imagen OG',
      ogImagePlaceholder: 'https://tudominio.com/og-image.jpg',
      ogImageExtra: 'Se recomienda 1200×630 — mostrada en tarjetas de compartir de Facebook / Twitter / LinkedIn',
      ogUploadText: 'Subir Imagen OG',
      serpPreviewTitle: 'Vista Previa SERP de Google',
      serpPreviewHint: 'La vista previa se actualiza mientras escribes. Google puede mostrar texto diferente.',
      cancel: 'Cancelar',
      save: 'Guardar',
      saveOk: 'Plantilla SEO actualizada',
      createOk: 'Plantilla SEO creada',
      saveError: 'Fallo al guardar. Por favor, intenta de nuevo.',
      enabled: 'Estado',
      enabledOn: 'Habilitado',
      enabledOff: 'Deshabilitado',
    },
      ogComplete: 'Completado',
},
  author: {
    titleAdd: 'Añadir Autor',
    titleEdit: 'Editar Autor',
    addBtn: 'Añadir Autor',
    viewAuthorPage: 'Ver página de autor',
    viewAuthorPageUnavailable: 'URL base del sitio (h5BaseUrl) no configurada; página de autor no disponible',
    col: {
      avatar: 'Avatar',
      displayName: 'Nombre Mostrado',
      slug: 'Slug',
      jobTitle: 'Título del Puesto',
      socials: 'Redes Sociales',
      articleCount: 'Artículos',
      status: 'Estado',
      createTime: 'Creado En',
      authorPage: 'Página de Autor',
      action: 'Acciones',
        expertiseTags: 'Experiencia',
    redditNoSameAs: 'Reddit — no incluido en sameAs (por SOP)',
},
    form: {
      displayName: 'Nombre Mostrado',
      displayNameRequired: 'Por favor, ingresa nombre mostrado',
      displayNamePlaceholder: 'Nombre mostrado del autor',
      slug: 'Slug (URL página del autor)',
      slugRequired: 'Por favor, ingresa slug',
      slugFormat: 'Slug debe ser letras minúsculas e guiones (kebab-case)',
      slugTaken: 'Este slug ya está en uso, elige otro',
      slugPlaceholder: 'ej. jomar-dela-cruz',
      jobTitle: 'Título del Puesto',
      jobTitleRequired: 'Por favor, ingresa título del puesto',
      jobTitlePlaceholder: 'ej. Senior Content Editor',
      location: 'Ubicación',
      expertiseTags: 'Etiquetas de Experiencia (3-5, knowsAbout)',
      expertiseTagsTip: 'Presiona intro para añadir',
      quoteHighlight: 'Resalta de Cita',
      quoteHighlightPlaceholder: 'Cita de firma del autor (mostrada en página de autor)',
      joinedAt: 'Se Unió En',
      avatar: 'Avatar (≥400px)',
      uploadAvatar: 'Subir',
      bio: 'Biografía',
      bioPlaceholder: 'Biografía del autor',
      socials: 'Redes Sociales (LinkedIn requerida)',
      linkedinRequired: 'LinkedIn es requerida y no se puede eliminar',
      addSocial: 'Añadir Red Social',
      platform: 'Plataforma',
      handle: 'Usuario',
      url: 'URL',
      sameAs: 'sameAs',
      exclude: 'Excluir',
      status: 'Estado',
      enabled: 'Habilitado',
      disabled: 'Deshabilitado',
        editorialApproach: 'Enfoque Editorial',
    editorialApproachPlaceholder: 'Describe el estilo editorial y estándares de este autor',
    previewSchema: 'Vista Previa Person Schema (JSON-LD)',
},
    frm: {
      displayNamePlaceholder: 'Buscar nombre mostrado',
      jobTitlePlaceholder: 'Buscar título del puesto',
      statusPlaceholder: 'Seleccionar estado',
    },
    msg: {
      createOk: 'Creado',
      updateOk: 'Actualizado',
      socialsSaveWarn: 'Autor guardado, pero las cuentas sociales fallaron; por favor, edita y guarda de nuevo',
      operateFail: 'Operación fallida',
      linkedinRequired: 'LinkedIn es requerida (URL necesaria)',
      avatarFormat: 'Solo JPG/PNG/WEBP soportado',
      avatarMaxSize: 'Imagen debe ser menor a 2MB',
      avatarTooSmall: 'Avatar debe ser ≥400×400px',
      urlInvalid: 'Por favor, ingresa una URL válida (comenzando con http(s)://)',
      deleteConfirm: '¿Estás seguro de que deseas eliminar este autor?',
      view: 'Ver',
        schemaSaveFirst: 'Guarda el autor primero para ver vista previa Person Schema.',
    schemaLoadFail: 'Fallo al cargar vista previa Person Schema.',
},
      infoBanner: 'Perfiles de autor más completos (título del puesto + experiencia + LinkedIn) producen Person schema más fuerte, ayudando a los motores de IA a identificar al autor como una autoridad de dominio.',
      infoBannerTitle: 'Perfiles de autor afectan la fuerza Person schema',
},
  siteBaseUrl: {
    title: 'URL Base del Sitio (h5BaseUrl)',
    declModeTip: 'Almacenado en Declaración del Sitio (fileType=siteConfig). Guardar publica una nueva versión; H5 SSR lee el valor publicado más reciente.',
    currentPublished: 'Publicado actual',
    publishBtn: 'Guardar y Publicar',
    publishOk: 'Publicado',
    addBtn: 'Añadir Configuración',
    notReady: 'Backend no listo',
    notReadyTip: 'La API de configuración del sitio aún no ha sido implementada (sin contrato Taylor). Todas las operaciones de escritura están deshabilitadas.',
    col: {
      platform: 'Plataforma',
      env: 'Entorno',
      h5BaseUrl: 'URL Base H5',
      remark: 'Observación',
      updateTime: 'Tiempo de Actualización',
      action: 'Acciones',
    },
    edit: {
      titleNew: 'Añadir Configuración del Sitio',
      titleEdit: 'Editar Configuración del Sitio',
      platformRequired: 'Por favor, ingresa plataforma',
      envRequired: 'Por favor, selecciona entorno',
      envPlaceholder: 'Seleccionar entorno',
      h5BaseUrlRequired: 'Por favor, ingresa URL base H5',
      h5BaseUrlInvalid: 'Por favor, ingresa una URL válida comenzando con http(s)://',
      h5BaseUrlTip: 'Sin barra al final, ej. https://www.fbmplay.com',
    },
  },
};
